import { createUseStyles } from 'react-jss'
import { GRAY, GUN_GRAY } from '@omnilert/components'

export default createUseStyles({
  listItem: {
    alignItems: 'center',
    borderBottom: `1px solid ${GRAY}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '25px 10px'
  },
  rightComponentContainer: {
    display: 'flex'
  },
  subtitle: {
    fontSize: '12px',
    color: GUN_GRAY
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '35px'
  },
  title: {
    fontSize: '18px',
    color: GUN_GRAY
  }
})
